module.exports = __webpack_public_path__ + "img/arrowBreadcrumbs.a0311ce0.svg";